import React from "react";

// status: 'green' | 'yellow' | 'red'
export const TrafficLight = ({ status = "green", size = "md", label }) => {
  const classes = {
    sm: "gap-1 p-1",
    md: "gap-1.5 p-1.5",
  }[size];
  return (
    <div
      className={`inline-flex items-center ${classes} border border-white/10 bg-black/40`}
      aria-label={label || `status-${status}`}
      data-testid={`traffic-light-${status}`}
    >
      <span className={`tl-dot ${status === "red" ? "active-red" : ""}`} />
      <span className={`tl-dot ${status === "yellow" ? "active-yellow" : ""}`} />
      <span className={`tl-dot ${status === "green" ? "active-green" : ""}`} />
    </div>
  );
};

export const getOilStatus = (car) => {
  const kmSince = (car.current_km ?? 0) - (car.last_oil_change_km ?? 0);
  const interval = car.oil_change_interval_km || 5000;
  const remaining = interval - kmSince;
  const pct = kmSince / interval;
  let level = "green";
  if (remaining <= 0 || pct >= 1.0) level = "red";
  else if (pct >= 0.8) level = "yellow";
  return { level, remaining, kmSince, pct };
};
